var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "m-b-xs-20" },
            [
              _c(
                "ak-button",
                { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                [
                  _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                    _vm._v("arrow_left"),
                  ]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("Ga terug")) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-8" }, [
          _c(
            "div",
            { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
            [
              _c(
                "div",
                { staticClass: "ak-panel__header ak-panel__header--small" },
                [
                  _c("div", { staticClass: "ak-panel__title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("Mail details")) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                    _c("tbody", [
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Onderwerp")) +
                              ":\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.mailLog.subject) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Van")) +
                              ":\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.mailLog.from) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Naar")) +
                              ":\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.mailLog.to) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Body")) +
                              ":\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", {
                          staticClass: "ak-table-column",
                          domProps: { innerHTML: _vm._s(_vm.mailLog.body) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "ak-table-row" }, [
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("Datum verzonden")) +
                              ":\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "ak-table-column" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm._f("date-relative")(_vm.mailLog.date)
                              ) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }